import CreateLayoutGrid from './create.table-grid'
import { defaultPagination } from './helpers'
import UrlQueryParam from './url-query-param'

class DinoTableGridBase {
  defaultPagination = defaultPagination

  createTable = CreateLayoutGrid

  setUrlQuery = UrlQueryParam.setUrlQuery

  getUrlQuery = UrlQueryParam.getUrlQuery
}

const DinoTableGrid = new DinoTableGridBase()
export default DinoTableGrid
